import { styled } from '@linaria/react';
import { bodyFont, fonts, layout, semantic, space } from '../../theme/tokens';

export const FilterPillGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${space['space-200']};
  justify-content: flex-start;
  width: 100%;

  @media (min-width: ${layout.desktopBreakpoint}) {
    justify-content: flex-end;
    width: auto;
    margin-left: auto;
  }
`;

export const FilterPill = styled.button<{ $active?: boolean }>`
  font-family: ${bodyFont};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.medium};
  border: 1px solid
    ${({ $active }) => ($active ? semantic.border.selected : semantic.border.default)};
  background: ${({ $active }) => ($active ? semantic.text.primary : semantic.bg.canvas)};
  color: ${({ $active }) => ($active ? semantic.text.inverse : semantic.text.primary)};
  border-radius: 999px;
  padding: ${space['space-200']} ${space['space-500']};
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;

  &:hover {
    background: ${({ $active }) => ($active ? semantic.text.primary : semantic.bg.surfaceSubtle)};
  }
`;
